<template>
  <div>
    <b-modal
      v-model="configModal.show"
      id="modal-1"
      @ok="submit"
      title="Chọn công ty lữ hành"
    >
      <el-form
        :model="mData.dataForm"
        :rules="mData.validForm"
        ref="myFormDonViCungCap"
        label-width="100%"
        label-position="top"
      >
        <b-row>
          <b-col md="12">
            <el-form-item
              label="Chọn công ty lữ hành"
              prop="id"
            >
              <el-select
                placeholder="Chọn công ty lữ hành"
                clearable
                v-model="mData.dataForm.id"
                filterable
              >
                <el-option
                  v-for="item in mData.listCongTyLuHanh"
                  :key="item.id"
                  :label="item.ten.vi"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </b-col>
        </b-row>
      </el-form>
    </b-modal>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import CongTyLuHanhModel from '@/views/admin/CongTyLuHanh/CongTyLuHanhModel';
import CongTyLuHanhApi from '@/moduleApi/CongTyLuHanhApi';
export default {
  props: ["configModal", "dataObject"],
  components: {},
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "VuiChoiGiaiTri",
        currentUser: JSON.parse(localStorage.getItem("currentUser")),
        dataDefault: {
          listProvince: [],
        },
        listCongTyLuHanh: [],
        dataForm: MethodService.copyObject(CongTyLuHanhModel.dataForm),
      },
    };
  },
  methods: {
    async load(keyword = "") {
      const res = await CongTyLuHanhApi.list({
        filters: "$fields=id,isDisabled,ten"
      });
      this.mData.listCongTyLuHanh = res.result;
    },
    async submit(evt) {
      evt.preventDefault();
      this.$refs["myFormDonViCungCap"].validate(async (valid) => {
         if (valid) {
          this.$emit("submit", {
            congTyLuHanhId: this.mData.dataForm.id,
          });
        }
      });
    },
  },
  mounted() {
    this.load();
  },
};
</script>
